export default __webpack_public_path__ + "static/media/ruhacks_logo.765272f8.png";